const FIELDS_GROUP_BY = {
  NONE: 'None',
  VALUES: 'Values',
  RECORDS: 'Records',
};

export default FIELDS_GROUP_BY;
